import React from 'react';
import Button from 'components/common/Button';
import { logger } from 'utils/logger';
import './ErrorBoundary.css';

/**
 * Top-level error boundary. Catches render-time errors so a single broken
 * screen never takes down the whole app, and logs them for debugging.
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    logger.error('Render error caught by ErrorBoundary', error, info);
  }

  handleReset = () => {
    this.setState({ hasError: false, error: null });
    window.location.assign('/');
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="kvo-error-boundary">
          <div className="kvo-error-boundary__card">
            <h1>Something went wrong</h1>
            <p>An unexpected error occurred. Try reloading the page.</p>
            <Button onClick={this.handleReset}>Back to home</Button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
